import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getFlightDataWithId, updateFlight } from "adminApi/TransportFacilityApi/FlightApi.js";
import { validateForm } from "utils/validation";
import { FlightRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/FlightFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import FlightForm from "../AddFlight/components/FlightForm";
import useFetchAllData from "Hooks/useFetchAllData";

const EditFlight = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    const {
        values,
        errors,
        handleChange,
        setErrors,
        setValues
    } = useFormChange(initialValues, FlightRules);

    // Fetch existing data
    const fetchFlight = useMemo(() => () => getFlightDataWithId(id), [id]);
    const { data: flightData, loading: fetchLoading } = useFetchAllData(fetchFlight);

    useEffect(() => {
        if (flightData) {
            // Format dates for datetime-local input (YYYY-MM-DDTHH:mm)
            const formattedData = { ...flightData };
            if (formattedData.departure) {
                formattedData.departure = formattedData.departure.substring(0, 16);
            }
            if (formattedData.arrival) {
                formattedData.arrival = formattedData.arrival.substring(0, 16);
            }
            setValues(formattedData);
        }
    }, [flightData, setValues]);

    const { loading: updateLoading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await updateFlight({ id, data: formValues });
        },

        (vals) => {
            const err = validateForm(vals, FlightRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Flight Updated Successfully"
    );

    const loading = fetchLoading || updateLoading;

    return (
        <>
            {loading && <Spinner isSpinner />}
            <FlightForm
                title="Edit Flight"
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                btnLabel="Update"
            />
        </>
    );
};

export default EditFlight;